/**
 * Normalizes a SignalR service base URL so it always has exactly one trailing slash.
 * Accepts domain with or without an ending slash (e.g. https://qca-s4-signalr.azurewebsites.net or .../).
 * Use the result when appending hub path: normalizedUrl + 'NotificationHub'
 */
export function normalizeSignalRBaseUrl(url: string): string {
  if (url == null || typeof url !== 'string') return url;
  const trimmed = url.trim().replace(/\/+$/, '');
  return trimmed ? `${trimmed}/` : url;
}
